import { Search as SemanticSearch } from 'semantic-ui-react';
import styled from 'styled-components';

const SearchInput = styled(SemanticSearch)`
  &.ui.search .prompt {
    color: ${(props) => props.theme.color.searchInputTextActive};
    font-family: Roboto;
    border-color: ${(props) => props.theme.color.searchInputBorder};
    border-radius: 4px !important;
    font-size: 14px;
    height: 38px;
    padding: 10px;
    width: ${({ width }) => (width || '350px')};
  }

  &&&.ui.search {
    display: flex;
    flex: 1;
  }
  
  &&&.ui > .input {
    width: 100%;
  }

  &&&.ui.search .prompt {
    border-radius: 4px 0px 0 4px !important;
    border-right: ${(props) => (props.iswritten ? '' : 'none')};
  }

  .icon {
    color: ${(props) => props.theme.color.primary};
    font-size: 15px;
    padding: 0px;
    opacity: initial !important;
  }
`;

const ClearButtonContainer = styled.div`
  display: flex;
  align-items: center;
  padding-right: 8px;
  height: 38px;
  min-width: 44px;
`;

const ClearButton = styled.span`
  font-size: 14px;
  color:  ${({ theme }) => theme.color.primary};
  cursor: pointer;
`;

const SearchInputContainer = styled.div`
  display: ${(props) => (props.iswritten ? '' : 'flex')};
  flex: ${(props) => (props.iswritten ? '' : 1)};
  align-items: center;
  color: ${({ theme }) => theme.color.text};
  font-family: Roboto;
  border-color: ${({ theme }) => theme.color.searchInputBorder};
  border-radius: 4px;
  font-size: 14px;
  height: 38px;
  width: ${(props) => (props.iswritten ? '' : '100%')};
  border: ${(props) => (props.iswritten ? '' : '1px solid rgba(34,36,38,.15)')};
  border-left: none;
  background-color: ${({ theme }) => theme.color.white};
`;

export {
  SearchInput,
  ClearButtonContainer,
  ClearButton,
  SearchInputContainer,
};
